export function getUserData(): {
  userId: string;
  instId?: string;
} {
  return {
    userId: window.gProxy.getToken().UserId || "guest",
    instId: window.gProxy.getToken().InstId || undefined,
  };
}
